import lazyRequire from "../../../util/lazyRequire";
export class VortexModTester {
    fomod;
    constructor() {
        this.fomod = lazyRequire(() => require("@nexusmods/fomod-installer-native"));
    }
    /**
     * Calls FOMOD's testSupport and converts the result to Vortex data
     */
    testSupport = (files, allowedTypes) => {
        try {
            const result = this.fomod.NativeModInstaller.testSupported(files, allowedTypes);
            return {
                supported: result.supported,
                requiredFiles: result.requiredFiles,
            };
        }
        catch (error) {
            return {
                supported: false,
                requiredFiles: [],
            };
        }
    };
}
